import {
  OFFLINE_ORDER_EXECUTION_TYPE,
  ZONE_ORDER_EXECUTION_TYPE,
} from '../constants';

const isOfflineMarketOrder = (orderExecutionType: string | null) => {
  return (
    orderExecutionType === OFFLINE_ORDER_EXECUTION_TYPE.market.next ||
    orderExecutionType === OFFLINE_ORDER_EXECUTION_TYPE.market.helium ||
    orderExecutionType === ZONE_ORDER_EXECUTION_TYPE
  );
};

export { isOfflineMarketOrder };
